<template>
	<div>
		<el-dialog title="选择分组" @open="open" :visible.sync="visible" width="50%" destroy-on-close append-to-body>

			<el-table v-loading="loading" :data="list" border style="width: 100%;margin-top:15px;" size="small" :header-cell-style="headerStyle"  @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="id" label="组编号" align="center"></el-table-column>
				<el-table-column prop="groupName" label="组名稱" align="center"></el-table-column>
			</el-table>
			<div class="pager">
				<el-pagination background @current-change="handleCurrentChange" :current-page="page"
					:page-size="pageSize" layout="total, prev, pager, next, jumper" :total="dataObj.total">
				</el-pagination>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="visible = false">取 消</el-button>
				<el-button type="primary" size="small" @click="submit">確 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				headerStyle: {
					'background': '#f9f9f9',
					'color': '#666'
				},
				visible: false,
				loading:true,
				searchForm: {
					store_name: "",
					cate_id:""
				},
				page: 1,
				pageSize: 20,
				list: [],
				dataObj: {},
				selectedList:[],
				categoryList:[]
			}
		},
		mounted() {

		},
		methods: {
			handleCurrentChange(e){
				this.page = e;
				this.getProductList();
			},
			handleSelectionChange(e){
				this.selectedList = e;
			},
			doSearch(){
				this.page = 1;
				this.getProductList();
			},
			doReset(){
				this.page = 1;
				this.searchForm = {
					store_name: "",
					cate_id:""
				};
				this.getProductList();
			},
			submit(){
				this.$emit("submit",this.selectedList);
				this.visible = false;
			},
			open() {
				this.page = 1;
				this.searchForm = {
					store_name: "",
					cate_id:""
				};
				this.getProductList();
			},
			getProductList() {
				this.$request({
					url: this.$api.common.getGroupList,
					data: {
						page: this.page,
						pageSize: this.pageSize,
					}
				}).then((res) => {
					this.list = res.data.data.data;
					this.dataObj = res.data.data;
					this.loading = false;
				})
			}
		}
	}
</script>

<style scoped>
	.pager{
		margin-top:15px;
		display: flex;
		justify-content:flex-end;
	}
</style>



// WEBPACK FOOTER //
// src/components/group/groupDialog.vue